import JSZip from "jszip";
import { KIT, LAUNCH_DATE, teasersFor } from "@/data/kit";
import { REPLY_BANK } from "@/data/replies";
import { RUN_SHEET } from "@/data/runsheet";

const fetchBlob = async (path) => {
  const r = await fetch(path);
  if (!r.ok) throw new Error(`Missing ${path}`);
  return r.blob();
};

const postBlock = (lines, p, i, folder) => {
  lines.push(`#${i + 1}  ${p.date}  —  ${p.title}`);
  lines.push(`Image: images/${folder}/${p.image}${p.story ? `   Story: images/stories/${p.story}` : ""}`);
  if (p.note) lines.push(`How to: ${p.note}`);
  lines.push("", p.caption);
  if (p.tags.length) lines.push("", p.tags.join(" "));
  lines.push("", "-".repeat(60), "");
};

const captionsText = (networkName, k, teasers) => {
  const lines = [
    `HEARTHVAULT — ${networkName.toUpperCase()} LAUNCH KIT`,
    `Launch: ${LAUNCH_DATE}`,
    "",
    "=== PROFILE SETUP ===",
    "",
  ];
  for (const [label, value] of Object.entries(k.page)) lines.push(`--- ${label} ---`, value, "");
  lines.push("=== IMAGES ===", "");
  for (const a of k.assets) lines.push(`${a.file}  ·  ${a.label}  ·  ${a.dims}  ·  ${a.use}`);
  lines.push("", "=== COUNTDOWN TEASERS (8–14 Nov) ===", "");
  teasers.forEach((p, i) => postBlock(lines, p, i, "teasers"));
  lines.push("", "=== LAUNCH CALENDAR (from 15 Nov) ===", "");
  k.posts.forEach((p, i) => postBlock(lines, p, i, "posts"));
  return lines.join("\n");
};

export const downloadKitZip = async (networkKey, networkName, onProgress) => {
  const k = KIT[networkKey];
  const teasers = teasersFor(networkKey);
  const zip = new JSZip();
  const root = zip.folder(`hearthvault-${networkKey}-launch-kit`);
  root.file("captions-and-dates.txt", captionsText(networkName, k, teasers));
  root.file("launch-day-run-sheet.txt", [RUN_SHEET.title.toUpperCase(), RUN_SHEET.date, "", RUN_SHEET.intro, "", ...RUN_SHEET.blocks.flatMap((b) => [`== ${b.t} ==`, ...b.items.map((i) => `[ ] ${i.time}  ${i.what}  (${i.where})`), ""]), RUN_SHEET.footer].join("\n"));
  root.file("comment-replies.txt", REPLY_BANK.map((c) => [`=== ${c.title.toUpperCase()} ===`, "", ...c.items.flatMap((i) => [`Q: ${i.q}`, `Short: ${i.short}`, `Long: ${i.long}`, ""])].join("\n")).join("\n"));

  const files = [
    ...k.assets.map((a) => ({ folder: "images/profile", file: a.file })),
    ...k.posts.map((p) => ({ folder: "images/posts", file: p.image })),
    ...k.posts.filter((p) => p.story).map((p) => ({ folder: "images/stories", file: p.story })),
    ...teasers.map((p) => ({ folder: "images/teasers", file: p.image })),
    ...teasers.map((p) => ({ folder: "images/stories", file: p.story })),
  ];
  const seen = new Set();
  const unique = files.filter((f) => { const id = `${f.folder}/${f.file}`; if (seen.has(id)) return false; seen.add(id); return true; });

  let done = 0;
  await Promise.all(unique.map(async (f) => {
    root.folder(f.folder).file(f.file, await fetchBlob(`/kit/${f.file}`));
    done += 1; onProgress?.(done, unique.length);
  }));

  const blob = await zip.generateAsync({ type: "blob" });
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: `hearthvault-${networkKey}-launch-kit.zip` });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
};
